<template>
  <div class="category-showcase-wrapper py-3 py-md-4">
    <div class="container-fluid px-3 px-md-5">
      <div class="category-header-title text-center mb-3">
        <span class="category-badge">
          <font-awesome-icon icon="th-large" class="me-1" style="font-size: 10px;" /> Categorías Principales
        </span>
      </div>

      <div class="categories-grid d-flex justify-content-center flex-wrap gap-3 gap-md-4">
        <div 
          v-for="categoria in categories" 
          :key="categoria.id" 
          @click="filtrarCategoria(categoria.id)" 
          class="category-card d-flex align-items-center"
        >
          <!-- Ring Avatar con Gradiente de Marca -->
          <div class="avatar-ring-wrap me-3">
            <div class="avatar-ring">
              <img 
                v-if="categoria.imagen" 
                :src="`${dominio}/img/categorias/${categoria.imagen}`" 
                class="category-img" 
                :alt="categoria.nombre"
              />
              <div v-else class="avatar-placeholder">
                <font-awesome-icon icon="tag" class="placeholder-icon" />
              </div>
            </div>
          </div>

          <!-- Información de la Categoría -->
          <div class="category-info">
            <h6 class="category-title mb-0">{{ categoria.nombre }}</h6>
            <span class="category-action">
              Explorar <font-awesome-icon icon="chevron-right" class="action-icon" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CategoriasProducto',
  data() {
    return {
      dominio: this.$store.state.dominio
    }
  },
  methods: {
    filtrarCategoria(id) {
      this.$store.dispatch('getProductosCat', id);
      this.$router.push('/tienda/' + id).catch(() => {});
    }
  },
  computed: {
    ...mapState(['categories'])
  }
}
</script>

<style lang="scss" scoped>
.category-showcase-wrapper {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  width: 100%;
  position: relative;
  z-index: 5;
}

.category-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: #713083;
  background: rgba(113, 48, 131, 0.08);
  padding: 5px 16px;
  border-radius: 20px;
  text-transform: uppercase;
  border: 1px solid rgba(113, 48, 131, 0.15);
}

.categories-grid {
  display: flex;
  justify-content: center;
  align-items: center;
}

.category-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 10px 20px 10px 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  min-width: 210px;
  max-width: 280px;
  flex: 1 1 calc(50% - 16px);

  @media (min-width: 992px) {
    flex: 0 1 auto;
    min-width: 230px;
  }

  &:hover {
    transform: translateY(-4px);
    background: #ffffff;
    border-color: rgba(113, 48, 131, 0.3);
    box-shadow: 0 12px 25px rgba(113, 48, 131, 0.15);

    .avatar-ring {
      transform: scale(1.06);
    }

    .category-title {
      color: #713083;
    }

    .action-icon {
      transform: translateX(4px);
      color: #cc161d;
    }
  }
}

.avatar-ring-wrap {
  flex-shrink: 0;
}

.avatar-ring {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  padding: 2.5px;
  background: linear-gradient(135deg, #713083 0%, #cc161d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  box-shadow: 0 3px 8px rgba(113, 48, 131, 0.25);
}

.category-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid #ffffff;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #f1f5f9;
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-icon {
  font-size: 1.2rem;
  color: #64748b;
}

.category-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.category-title {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.25;
  transition: color 0.2s ease;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.category-action {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-icon {
  font-size: 0.65rem;
  transition: transform 0.2s ease, color 0.2s ease;
}
</style>